import popover from '@app/adapters/popover'

export default () => {
  // TODO: Is this really needed anymore?
  // TODO: Add a test

  onDomLoad(($dom) => {
    const elements = $dom[0].querySelectorAll(
      'a[rel~=popover], [data-toggle~=popover]'
    )

    elements.forEach((element) => {
      popover(element)
    })
  })
}
